module.exports = __webpack_public_path__ + "static/img/pay-bg.e4aafce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pay-bg.png
// module id = ENQX
// module chunks = 3